import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../app.settings';
import { Section } from '../models/section';
import { Competition } from '../models/competition';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompetitionService {

  constructor(private http: HttpClient) { }

  getObservableCompetitionListByNameAtHorseShow(horse_show_id: string, competition_name: string): Observable<Competition[]> {
	 return  this.getObservableCompetitionListWithRESTUrlFilter("horse_show_id/" + horse_show_id + "/name/" + competition_name);
  }

  getObservableSectionListByNameAtHorseShow(horse_show_id: string, section_name: string): Observable<Section[]> {
     return  this.getObservableSectionListWithRESTUrlFilter("horse_show_id/" + horse_show_id + "/name/" + section_name);
  }

  getObservableCompetitionListByNameAtHorseShowForEntryType(horse_show_id: string, competition_name: string, entry_type: number): Observable<Competition[]> {
	 return  this.getObservableCompetitionListWithRESTUrlFilter("horse_show_id/" + horse_show_id + "/name/" + competition_name + "/entry_type/" + entry_type);
  }

  getObservableSectionListByNameAtHorseShowForEntryType(horse_show_id: string, section_name: string, entry_type: number): Observable<Section[]> {
     return  this.getObservableSectionListWithRESTUrlFilter("horse_show_id/" + horse_show_id + "/name/" + section_name + "/entry_type/" + entry_type);
  }

  getAutoAddSectionsForEntryType(horse_show_id: string, entry_type: number): Promise<Section[]> {
	 return this.getSectionListWithRESTUrlFilter('horse_show_id/' + horse_show_id + '/entry_type/' + entry_type + '/auto_add/true');
  }

	private getObservableCompetitionListWithRESTUrlFilter(rest_url: string): Observable<Competition[]> {
    return this.http.get(AppSettings.API_ENDPOINT + 'competitions/' + rest_url).pipe(map((response: any) => {
      if(response.type == 'competitions'  && response.data){
        return response.data;
      }
    }));
    }

   	private getObservableSectionListWithRESTUrlFilter(rest_url: string): Observable<Section[]> {
      return this.http.get(AppSettings.API_ENDPOINT + 'sections/' + rest_url).pipe(map((response: any)=> {
        if(response.type == 'sections'  && response.data){
          return response.data;
        }
      }));
    }

	getCompetitionListByNameAtHorseShow(horse_show_id: string, competition_name: string): Promise<Competition[]> {
	     return this.getCompetitionListWithRESTUrlFilter("horse_show_id/" + horse_show_id + "/name/" + competition_name);
	  }


	getCompetitionByNumberAtHorseShow(horse_show_id: string, competition_number: number, entry_type_number: number): Promise<Competition> {
	     return this.getCompetitionWithRESTUrlFilter("horse_show_id/" + horse_show_id + "/number/" + competition_number + "/entry_type/" + entry_type_number);
	  }

	  getCompetitionByNumber(horse_show_id: string, competition_number: number): Promise<Competition> {
	     return this.getCompetitionWithRESTUrlFilter("horse_show_id/" + horse_show_id + "/number/" + competition_number);
	  }

	 getCompetitionListByHorseShowAndEntryType(horse_show_id: string, entry_type: number): Promise<Competition[]> {
    	return this.getCompetitionListWithRESTUrlFilter('horse_show_id/' + horse_show_id + '/entry_type/' + entry_type);
    }

    getCompetitionListByHorseShow(horse_show_id: string): Promise<Competition[]> {
    	return this.getCompetitionListWithRESTUrlFilter('horse_show_id/' + horse_show_id);
    }

    private getCompetitionWithRESTUrlFilter(rest_url: string): Promise<Competition> {
    	   return new Promise((resolve, reject) => {
				return this.http.get(AppSettings.API_ENDPOINT + 'competitions/' + rest_url).subscribe((response:any) => {
					if(response.type == 'competition' && response.data){
						resolve(response.data);
					} else {
						reject(response);
					}

				},
					error => {
			      		if(error instanceof HttpErrorResponse){
		            	  reject(error.error);
		            	} else {
		            		reject(error);
		            	}
					});
			});
    }

    private getCompetitionListWithRESTUrlFilter(rest_url: string): Promise<Competition[]> {
    	   return new Promise((resolve, reject) => {
				return this.http.get(AppSettings.API_ENDPOINT + 'competitions/' + rest_url).subscribe((response:any) => {
					if(response.type == 'competitions' && response.data){
						resolve(response.data);
					} else {
						reject(response);
					}

				},
					error => {
			      		if(error instanceof HttpErrorResponse){
            	  			reject(error.error);
            			} else {
            				reject(error);
            			}
					});
			});
    }



	getSectionListByHorseShow(horse_show_id: string): Promise<Section[]> {
    	return this.getSectionListWithRESTUrlFilter('horse_show_id/' + horse_show_id);
    }

    getSectionListByHorseShowAndEntryType(horse_show_id: string, entry_type: number): Promise<Section[]> {
    	return this.getSectionListWithRESTUrlFilter('horse_show_id/' + horse_show_id + '/entry_type/' + entry_type);
    }

    getSection(section_id: string): Promise<Section> {
    	return  this.getSectionWithRESTUrlFilter('id/' + section_id);
    }

    getSectionByNumberAtHorseShow(horse_show_id: string, section_number: number, entry_type_number: number){
     return  this.getSectionWithRESTUrlFilter('horse_show_id/' + horse_show_id + '/number/' + section_number + '/entry_type/' + entry_type_number);
    }

    private getSectionListWithRESTUrlFilter(rest_url: string): Promise<Section[]> {
           return new Promise((resolve, reject) => {
				return this.http.get(AppSettings.API_ENDPOINT + 'sections/' + rest_url).subscribe((response:any) => {
					if(response.type == 'sections' && response.data){
						resolve(response.data);
					} else {
						reject(response);
					}

				},
					error => {
			      	 if(error instanceof HttpErrorResponse){
            	  		reject(error.error);
            		} else {
            			reject(error);
            		}
				});
			});
    }

    private getSectionWithRESTUrlFilter(rest_url: string): Promise<Section> {
		return new Promise((resolve, reject) => {
			return this.http.get(AppSettings.API_ENDPOINT + 'sections/' + rest_url).subscribe((response:any) => {
				if(response.type == 'section' && response.data){
					resolve(response.data);
				} else {
					reject(response);
				}

			},
				error => {
			      	if(error instanceof HttpErrorResponse){
	            	  reject(error.error);
	            	} else {
	            	  reject(error);
	            	}
				});
		});
    }


}
